import { blue, green, orange, purple, red, yellow } from 'enable-ui';

export const LETTER_COLOR_CONFIG = Object.freeze({
  AGMSY: blue['blue-5'],
  BHNTZ: purple['purple-5'],
  CIOU: yellow['yellow-5'],
  DJPV: red['red-5'],
  EKQW: orange['orange-5'],
  FLRX: green['green-5'],
});

export const MAX_FILE_SIZE = 10 * 1024 * 1024; //Max file size is 10Mb
export const MAX_VIDEO_SIZE = 200 * 1024 * 1024; //Max file size is 200Mb
